import axios from 'axios';
import { config } from '../config';
import {
  requestAuthInterceptor,
  requestErrorInterceptor,
  responseSuccessInterceptor,
  responseErrorInterceptor,
} from './interceptors';

export const API_BASE_URL = config.apiUrl;

const apiClient = axios.create({
  baseURL: config.apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(requestAuthInterceptor, requestErrorInterceptor);
apiClient.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default apiClient;
